<template>
  <div :class="$style.container">
    <DolphinSelector
      v-model="typeForm"
      :options="actionOptions"
      :class="$style.inputType"
    />
    <div
      v-if="model.type === 'ReadRoomAuthzPolicyAction'"
      :class="$style.inputEachField"
    >
      <DolphinCheckbox v-model="model.isAssigned" :class="$style.inputText" />
      <p>担当のチャットのみ</p>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import {
  AuthzPolicyActionTypeValues,
  AuthzPolicyActionTypeText,
} from '../types'
import DolphinSelector from '@/components/atoms/DolphinSelector.vue'
import DolphinCheckbox from '@/components/atoms/DolphinCheckbox.vue'

type AnyAuthzPolicyAction = {
  type: 'AnyAuthzPolicyAction'
}
type ReadRoomAuthzPolicyAction = {
  type: 'ReadRoomAuthzPolicyAction'
  isAssigned: boolean
}

export type AuthzPolicyActionForm =
  AnyAuthzPolicyAction | ReadRoomAuthzPolicyAction

const model = defineModel<AuthzPolicyActionForm>({ required: true })

const typeForm = computed({
  get: () => model.value.type,
  set: value => {
    switch (value) {
      case 'AnyAuthzPolicyAction':
        model.value = {
          type: value,
        }
        break
      case 'ReadRoomAuthzPolicyAction':
        model.value = {
          type: value,
          isAssigned: false,
        }
        break
    }
  },
})

const actionOptions = computed(() =>
  AuthzPolicyActionTypeValues.map(value => ({
    value,
    text: AuthzPolicyActionTypeText[value],
  }))
)
</script>

<style lang="scss" module>
.container {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.inputType {
  width: 200px;
}

.inputEachField {
  display: flex;
  gap: 8px;
  align-items: center;
}
</style>
